module.exports = __webpack_public_path__ + "img/c1.27e6c7ab.png";